/** E2E-22: search matches name OR category. */
export function matchesSearch(row, search) {
    const query = search.trim().toLowerCase();
    if (!query)
        return true;
    return row.name.toLowerCase().includes(query) || row.categoryLabel.toLowerCase().includes(query);
}
/**
 * Empty selection = filter inactive (matches everything). Otherwise OR-match.
 * `selected` is `(string | number)[]` because `@ui`'s `MultiSelectFilterConfig`
 * is generic over `string | number` — our own values are always strings, so
 * they're normalized to strings before comparing.
 */
export function matchesMultiSelect(values, selected) {
    if (selected.length === 0)
        return true;
    const selectedStrings = selected.map(String);
    return values.some((value) => selectedStrings.includes(value));
}
export function filterAttachmentRows(rows, search, categoryValues, visibilityValues, fileTypeValues) {
    return rows.filter((row) => matchesSearch(row, search) &&
        matchesMultiSelect([row.categoryFilterValue], categoryValues) &&
        matchesMultiSelect(row.visibilityKeys, visibilityValues) &&
        matchesMultiSelect([row.typeFilterValue], fileTypeValues));
}
